import * as React from "react";
import {
  Page,
  Navbar,
  Block,
  List,
  ListItem,
  BlockTitle,
  Button,
  Col,
  Row,
  Icon,
} from "framework7-react";
import { removeToken } from "src/utils/utils";
import { COMPANY_NAME } from "src/utils/constants";

export default class PanelLeftPage extends React.Component {
  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  public logout() {
    const dialog = this.$f7?.dialog.preloader("Cerrando sesión");
    dialog?.open();

    setTimeout(() => {
      removeToken();
      dialog?.close();

      const form = document.querySelector("#login-form") as HTMLFormElement;
      form.reset();

      const loginPageDialog = document.querySelector(
        "#login-screen"
      ) as HTMLElement;

      this.$f7?.loginScreen.open(loginPageDialog);
    }, 600);
  }

  public changeMarket() {
    console.log("yeah");
  }

  public render() {
    return (
      <Page panelLeftBreakpoint="400">
        <Navbar title={COMPANY_NAME} />

        <List>
          <ListItem
            className={"bg-white"}
            title="Mercado:"
            smartSelect
            smartSelectParams={{ openIn: "popover" }}
          >
            <select
              onChange={this.changeMarket}
              name="mercado"
              defaultValue={["MercadoLibre"]}
            >
              <option value="MercadoLibre">MercadoLibre</option>
              <option disabled value="Walmart">
                Walmart
              </option>
              <option disabled value="Amazon">
                Amazon
              </option>
            </select>
          </ListItem>
        </List>
        <BlockTitle>Menu de Opciones</BlockTitle>
        <List>
          <ListItem
            className={"bg-white"}
            link="/"
            title="Inicio"
            icon={"icon icon-home"}
            view="#main-view"
            panelClose
          >
            <Icon slot="media" icon="icon icon-home" />
          </ListItem>
          {/* INIT-GENERATOR.PHP ListItemConfig */}
          <ListItem
            className={"bg-white"}
            link="/internal-control/"
            title="Control Interno"
            view="#main-view"
            panelClose
          >
            <Icon slot="media" icon="icon icon-chevrons-right" />
          </ListItem>
          <ListItem
            className={"bg-white"}
            link="/competitors/"
            title="Competidores"
            view="#main-view"
            panelClose
          >
            <Icon slot="media" icon="icon icon-chevrons-right" />
          </ListItem>
          {/* END-GENERATOR.PHP ListItemConfig */}

          <Block>
            <Row>
              <Col>
                <Button fill color="red" raised onClick={this.logout}>
                  Cerrar sesión
                </Button>
              </Col>
            </Row>
          </Block>
        </List>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PanelLeftPage.tsx